
import { tryFind } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { Fields_tips } from "../Common/AppMessages.js";
import { label } from "../fable_modules/Fulma.3.0.0/Elements/Form/Label.fs.js";
import { singleton, empty } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { HTMLAttr } from "../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { dataTooltip } from "../fable_modules/Fulma.Extensions.Wikiki.Tooltip.4.0.0/Tooltip.fs.js";
import * as react from "react";
import { keyValueList } from "../fable_modules/fable-library-js.5.13.0/MapUtil.js";

/**
 * The explanations live in AppMessages.Fields, with the rest of Issie's longer text, so that
 * they can be read and reviewed as writing rather than found one at a time in the pane.
 * A field label carrying its explanation, where there is one to give.
 * 
 * The help cursor is the only marking: a dotted underline under every explained label put a row
 * of broken rules down a pane that is mostly labels, which read as structure that was not there.
 * 
 * The tooltip goes on a span INSIDE the label rather than on the label itself, because it needs
 * an element that shrinks to the width of the words - a tooltip anchored to a full-width box
 * points at nothing in particular - and a label made inline-block to achieve that stops being a
 * line of its own, so the field's input box comes up beside it and covers the words.
 */
export function fieldLabel(name) {
    let props;
    const matchValue = tryFind(name, Fields_tips);
    if (matchValue != null) {
        return label(empty(), singleton((props = [new HTMLAttr(/* ClassName */ 64, [`field-tip ${"tooltip"} ${"has-tooltip-multiline"} ${"has-tooltip-bottom"}`]), dataTooltip(matchValue), ["style", {
            cursor: "help",
            display: "inline-block",
        }]], react.createElement("span", keyValueList(props, 1), name))));
    }
    else {
        return label(empty(), singleton(name));
    }
}

